import type { ButtonHTMLAttributes } from "react";
import { useTranslation } from "./i18n";
import { toolIconPaths } from "./ToolIcon";

export function RecordActionIcon({ action }: { action: "print" | "export" }) {
  return (
    <svg
      className="record-action-icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      data-record-icon={action}
    >
      {action === "print" ? (
        <>
          <path d="M6 9V3h12v6M6 17H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2" />
          <path d="M6 14h12v7H6zM17 12h1" />
        </>
      ) : (
        <path d={toolIconPaths.export} />
      )}
    </svg>
  );
}

export default function RecordActionButton({
  action,
  children,
  className = "",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { action: "print" | "export" }) {
  const { t } = useTranslation("classroomInterface");
  return (
    <button type="button" className={`record-export-trigger ${className}`.trim()} {...props}>
      <RecordActionIcon action={action} />
      {children || t(action)}
    </button>
  );
}
